import { DialogService } from "@app/services/dialog.service";
import { CrudController, ICrudScope } from "@app/views/crud.view";
import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IKbUserEdit, IPasswordChange } from "@models";
import { IRootScope } from "@models";
import { icons } from "@tools";
import { AuthService } from "@app/services/auth.service";
import { KbService } from "@app/services/kb.service";
import { DrawerService } from "@app/services/drawer.service";
import { SignalrService } from "@app/services/signalr.service";
import { ApiService } from "@app/services/api.service";
import { CrudService } from "@app/services/crud.service";

export interface IChangePasswordScope extends ICrudScope<IPasswordChange> {
    kbUser: IKbUserEdit;
}

@NgView({
    token: Token.ChangePasswordView,
    inherit: [Token.CrudView],
    dependencies: [
        Token.$Scope,
        Token.CrudService
    ]
})
export class ChangePasswordController extends CrudController<IPasswordChange> {

    constructor(
        $scope: IChangePasswordScope,
        crudService: CrudService
    ) {

        super(
            $scope,
            crudService,
            { id: crudService.$stateParams.id } as any
        );

        $scope.model = { id: this.$stateParams.id } as any;
        this.drawerService.setHelpUrl(null);

        // add drawers
        let drSave = this.drawerService.addDrawer(icons.save, loc.save, $scope.save);
        let drCancel = this.drawerService.addDrawer(icons.cancel, loc.cancel, $scope.cancel);
    }

    public client(api: ApiService) {
        return api.changePassword;
    }

    public onSuccess() {
        this.$state.go("kb.admin.userEdit", { id: this.$stateParams.id });
    }

}
